import { Typography, Box } from "@mui/material";
import { useRef } from "react";
import Marquee from "react-fast-marquee";

import googleLogo from "../assets/images/google.png";
import microsoftLogo from "../assets/images/microsoft.png";
import amazonLogo from "../assets/images/amazon.png";
import facebookLogo from "../assets/images/facebook.png";
import ibmLogo from "../assets/images/ibm.png";
import accentureLogo from "../assets/images/accenture.png";
import cognizantLogo from "../assets/images/cognizant.png";
import deloitteLogo from "../assets/images/deloitte.png";


const StudentsHiredBySection = () => {
  const ref = useRef(null);

  return (
    <>
      {/* "Our Students Hired By" Section */}
      <Box sx={{ textAlign: "center", mt: 2,  }}>
        <Typography variant="h4" fontWeight="bold" color="#1E3A56">
          Our Students Were Hired By
        </Typography>
        <Marquee pauseOnHover speed={50} gradient gradientColor={[255, 255, 255]}>
          {[googleLogo, microsoftLogo, amazonLogo, facebookLogo, ibmLogo, accentureLogo, cognizantLogo, deloitteLogo].map((logo, idx) => (
            <img key={idx} src={logo} alt="Company Logo" width="110px" height="auto" style={{ margin: "20px", opacity: 0.9, objectFit: "contain" }} />
          ))}
        </Marquee>
      </Box>
    </>
  );
};

export default StudentsHiredBySection;
